/* eslint-disable react-hooks/exhaustive-deps */
import { debounce } from "lodash";
import { useCallback, useState } from "react";

const useAutoCloseTooltipDebouncer = () => {
  const DEBOUNCE_TIMER = 500;

  const [showTooltip, setShowTooltip] = useState(false);
  const debouncedSetTooltipVisible = useCallback(
    debounce((newVal: boolean) => setShowTooltip(newVal), DEBOUNCE_TIMER),
    [setShowTooltip]
  );

  return {
    showTooltip,
    debouncedSetTooltipVisible,
  } as const;
};

export default useAutoCloseTooltipDebouncer;
